import React from 'react'
import ComingSoon from '../assets/coming-soon.webp';
import BannerImg from '../assets/banner-img.webp';
import WhatWeDo from '../assets/what-we-do.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import { useNavigate } from 'react-router-dom';


const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* <div className='text-center align-content-center'>
      <img src={ComingSoon} className='img-fluid' /></div> */}

      {/* Banner section */}
      <section className='banner-bg'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-6 col-md-6 col-12 my-2 align-content-center'>
              <p className='banner-text d-flex'><hr className='banner-text-hr me-3' /> Welcome to Shakti Tours</p>
              <p className='banner-heading'>Let’s Travel<br />The World With Us</p>
              <button className='nav-btn' onClick={() => navigate('/about')}>Explore More<i class="fa-solid fa-arrow-right ps-2"></i></button>
            </div>

            <div className='col-lg-6 col-md-6 col-12 my-2 align-content-center text-center'>
              <img src={BannerImg} className='img-fluid' />
            </div>


          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Banner section ends */}


      {/* Benefits section */}
      <section className='py-5 bg-light'>
        <div className='container text-center py-md-5 py-4'>

          <p className='sec-subheading my-0'>Benefits we Provide</p>
          <p className='sec-heading'>Why you should choose us?</p>

          <div className='row mt-4'>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <div className='benefit-area'>
                <i class="fa-solid benefit-icon fa-tags"></i>
                <p className='benefit-text mt-2'>Budget Friendly Rates</p>
                <p>Enjoy exceptional travel experiences at affordable prices tailored to suit every budget.</p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <div className='benefit-area'>
                <i class="fa-solid benefit-icon fa-bell-concierge"></i>
                <p className='benefit-text mt-2'>Accomodations</p>
                <p>Stay comfortably in handpicked hotels and resorts offering quality, convenience, and great service.</p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2'>
              <div className='benefit-area'>
                <i class="fa-solid benefit-icon fa-cubes"></i>
                <p className='benefit-text mt-2'>Packaged Tours</p>
                <p>Explore hassle-free itineraries with transport, activities, and guides included for your convenience.</p>
              </div>
            </div>

          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Benefits section ends */}


      {/* Banner 2 section */}
      <section className='banner2-bg'>
        <div className='container text-center'>

          <p className='sec-subheading text-white'>Come & Join Us</p>
          <p className='sec-heading col-md-6 mx-auto mb-4'>Embark on a Journey To an Exciting World of Adventure.</p>

          <button className='nav-btn'>Tour Packages<i class="fa-solid fa-arrow-right ps-2"></i></button>


        </div>
      </section>
      {/* Banner 2 section ends */}


      {/* What we do section */}
      <section className='banner-bg pb-0'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-6 col-12 my-2'>
              <p className='sec-subheading'>What We Do?</p>
              <p className='sec-heading'>Making Adventure Tours and Activities Accessible</p>
              <div className='row text-center'>

                <div className='col-md-6 col-sm-6 col-12 my-2'>
                  <div className='benefit-area'>
                    <i class="fa-solid fa-suitcase-rolling benefit-icon"></i>
                    <p className='benefit-text my-2'>Exciting Journey</p>
                    <p className='para-text text-muted'>Create unforgettable travel memories through unique adventures.</p>
                  </div>
                </div>

                <div className='col-md-6 col-sm-6 col-12 my-2'>
                  <div className='benefit-area'>
                    <i class="fa-solid benefit-icon fa-user-tie"></i>
                    <p className='benefit-text my-2'>Expert Guides</p>
                    <p className='para-text text-muted'>Knowledgeable guides ensure safe and enriching experiences always.</p>
                  </div>
                </div>

                <div className='col-md-6 col-sm-6 col-12 my-2'>
                  <div className='benefit-area'>
                    <i class="fa-solid benefit-icon fa-box-open"></i>
                    <p className='benefit-text my-2'>Customized Packages</p>
                    <p className='para-text text-muted'>Tailor-made tours to fit your preferences, pace, and interests.</p>
                  </div>
                </div>

                <div className='col-md-6 col-sm-6 col-12 my-2'>
                  <div className='benefit-area'>
                    <i class="fa-solid benefit-icon fa-train"></i>
                    <p className='benefit-text my-2'>Scenic Trails</p>
                    <p className='para-text text-muted'>Explore natural landscapes on well-planned hiking routes.</p>
                  </div>
                </div>

              </div>
              {/* inner row ends */}
            </div>

            <div className='col-lg-6 col-12 mt-2 text-center'>
              <img src={WhatWeDo} className='img-fluid' alt='What We Do' />
            </div>


          </div>
          {/* row ends */}

        </div>
      </section>
      {/* What we do section ends */}


      {/* Testimonial section */}
      <section className='my-5'>
        <div className='container text-center'>

          <p className='sec-subheading'>Testimonials</p>
          <p className='sec-heading'>What our Clients are Saying</p>

          <Swiper spaceBetween={30} slidesPerView={3} modules={[Autoplay, Navigation]} loop={true} className='py-3 px-md-5 px-2'
            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              }
            }}>

            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>Shakti Tours made our vacation perfect—great planning, beautiful spots, and attentive service throughout the journey.</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>The guides were knowledgeable and friendly. Every detail was taken care of. Truly a stress-free vacation experience.</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>From scenic treks to cozy stays, Shakti Tours delivered an amazing mix of thrill and comfort making our holidays worthy.</p>
              </div>
            </SwiperSlide>


            <SwiperSlide>
              <div className='client-area'>
                <i class="fa-solid fa-quote-left client-icon"></i>
                <p className='mt-2'>Our custom tour package was perfect. Everything ran smoothly, and the team was always just a call away.</p>
              </div>
            </SwiperSlide>

          </Swiper>


        </div>
      </section>
      {/* Testimonial section ends */}

    </>
  )
}

export default Home
